import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import { apiService } from "lib/apiService";
import UniqueStatCards from "components/NewDashboard/UniqueStatCards";
import AreaYearlyExpenseChart from "components/NewDashboard/AreaYearlyExpenseChart";
import HighLevelPieChart from "components/NewDashboard/HighLevelPieChart";
import NetBalanceChart from "components/NewDashboard/NetBalanceChart";
import YearlyCreditDebitChart from "components/NewDashboard/YearlyCreditDebitChart";
import CategoryWiseExpenseChart from "components/NewDashboard/CategoryWiseExpenseChart";
import StackedBarCategoryChart from "components/NewDashboard/StackedBarCategoryChart";
import FinancialInsights from "components/NewDashboard/financialInsights";
import ExpenseTreeChart from "components/NewDashboard/ExpenseTreeChart";
import DailyExpenseChart from "components/NewDashboard/DailyExpenseChart";
import MonthlyRadarChart from "components/NewDashboard/MonthlyRadarChart";
import AnnualCategoryTrendsChart from "components/NewDashboard/AnnualCategoryTrendsChart";
import AdvancedPolarChart from "components/NewDashboard/AdvancedPolarChart";
import CategoryCumulativeChart from "components/NewDashboard/CategoryCumulativeChart";
import ExpenseChatbot from "components/Chatbot/ExpenseChatbot";

export default function NewExpenseDashboard() {
  const history = useHistory();
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  // const [selectedMonth] = useState(new Date().getMonth() + 1);
  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState("");
  const [years, setYears] = useState([]);
  const [currency, setCurrency] = useState("");
  const [selectedGlobalYear, setSelectedGlobalYear] = useState(new Date().getFullYear());
  const [selectedGlobalMonth, setSelectedGlobalMonth] = useState(new Date().getMonth() + 1);

  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  //get userid form loca storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  // Fetch available years + currency
  useEffect(() => {
    if (!groupId) return;

    async function loadData() {
      const fetchedYears = await apiService.getAvailableYears(groupId);
      setYears(fetchedYears);

      if (fetchedYears.length > 0) {
        // setSelectedYear(fetchedYears[fetchedYears.length - 1]);
      }

      const fetchedCurrency = await apiService.getCurrency(groupId);
      setCurrency(fetchedCurrency.currency === "INR" ? "₹" : "$");
    }

    loadData();
  }, [groupId]);

  return (
    <>
      <Navbar />
      <div className="custom-dashboard-container">
        {/* Header */}
        <div className="flex items-center justify-between mb-8 mt-2">
          <div>
            <h1 className="text-2xl font-bold">Expenses Dashboard</h1>
            {/* <p className="text-gray-600 mt-1">Complete overview of your financial data <strong>({selectedGlobalYear})</strong></p> */}
          </div>

          {/* Year dropdown */}
          <div>
            {/* YEAR DROPDOWN */}
            <select
              value={selectedGlobalYear}
              onChange={(e) => setSelectedGlobalYear(e.target.value)}
              className="rounded-md px-3 py-2"
              style={{ width: "100px", border: "1px solid #ddd" }}
            >
              {/* <option value="All">All Years</option> */}
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
            {/* MONTH DROPDOWN */}
            {/* <select
              value={selectedGlobalMonth}
              onChange={(e) => setSelectedGlobalMonth(e.target.value)}
              className="rounded-md px-3 py-2 ml-2"
              style={{ width: "120px", border: "1px solid #ddd" }}
            >
              <option value="All">All Months</option>
              {[
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ].map((month, index) => (
                <option key={month} value={index + 1}>
                  {month}
                </option>
              ))}
            </select> */}
          </div>
        </div>

        {/* Stat Cards */}
        <UniqueStatCards currency={currency} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />

        {/* Yearly Area, Pie */}
        <div className="newExpenseDashboardcharts-grid">
          <div id="yearly-credit-debit-chart" className="newExpenseDashboardchart-area">
            <AreaYearlyExpenseChart years={years} currency={currency} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />
          </div>

          <div className="newExpenseDashboardchart-pie">
            <HighLevelPieChart years={years} currency={currency} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />
          </div>
        </div>

        {/* Net Balance */}
        <div id="Net-balance-chart" className="grid grid-cols-1 md:grid-cols-1 mb-6 gap-4">
          <NetBalanceChart years={years} currency={currency} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />
        </div>

        <div className="newExpenseDashboardcharts-grid">
          <div id="category-trend-chart" className="newExpenseDashboardchart-area">
            <CategoryCumulativeChart years={years} currency={currency} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />
          </div>

          <div className="newExpenseDashboardchart-pie">
            <MonthlyRadarChart years={years} currency={currency} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />
          </div>
        </div>

        <div className="newExpenseDashboardchart-area mb-4">
          <CategoryWiseExpenseChart years={years} currency={currency} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />
        </div>

        {/* Credit vs Debit */}
        <div id="yearly-credit-vs-debit-chart" className="grid grid-cols-1 md:grid-cols-1 mb-6 gap-4">
          <YearlyCreditDebitChart years={years} currency={currency} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />
        </div>


        {/* Radar + Category */}
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <StackedBarCategoryChart years={years} currency={currency} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />
        </div>

        {/* Radar + Category */}
        <div className="grid grid-cols-1 lg:grid-cols-2">
        </div>

        {/* Annual Trends */}
        <div className="grid grid-cols-1 gap-6">
          <AnnualCategoryTrendsChart years={years} currency={currency} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />
        </div>

        {/* Stacked Bar + Polar */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-4">
          {/* <AdvancedPolarChart years={years} currency={currency}  selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} /> */}
        </div>

        {/* Daily Chart */}
        <div id="daily-expense-chart" className="grid grid-cols-1 lg:grid-cols-1 gap-6">
          <DailyExpenseChart years={years} currency={currency} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />
        </div>

        {/* Tree Graph */}
        <div className="grid grid-cols-1 lg:grid-cols-1 mb-6 gap-6">
          <ExpenseTreeChart years={years} currency={currency} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />
        </div>

        {/* <FinancialInsights currency={currency} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} /> */}
      </div>
      <ExpenseChatbot />
      <Footer />
    </>
  );
}
